import 'vue-select/dist/vue-select.css';

import Vue from 'vue';
import VueSelect from 'vue-select';

Vue.component('VSelect', VueSelect);

export default VueSelect;
